import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import PackagedSubDetail from '../../components/ac_packaged_unit/PackagedSubDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  editACPackagedSub,
  getACPackagedSub,
} from '../../redux/ac_packaged_unit/ac_packaged_sub_actions';

class ACPackagedSubEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.packagedSubDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.packagedSub !== nextProps.packagedSub && nextProps.show) {
      this.props.getACPackagedSub(nextProps.packagedSub.id);
    }
  }

  onSaveHandler() {
    const editPackagedSub = this.packagedSubDetail.getWrappedInstance().getPackagedSubData();
    this.props.editACPackagedSub({
      ...editPackagedSub,
      id: this.props.packagedSub.id,
    });
  }

  render() {
    const { isEditing, errorMessage, packagedSubInstance, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit ac packaged sub')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PackagedSubDetail
            packagedSub={packagedSubInstance}
            ref={ref => (this.packagedSubDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-package-sub-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.packagedSub.errorMessage,
  isEditing: state.ac.packagedSub.isEditing,
  packagedSubInstance: props.packagedSub && state.ac.packagedSub.objects[props.packagedSub.id],
});

const mapDispatchToProps = dispatch => ({
  editACPackagedSub: ac => defaultRejectHandler(dispatch(editACPackagedSub(ac.id, ac.name, ac.power_required, ac.description, ac.image))),
  getACPackagedSub: id => defaultRejectHandler(dispatch(getACPackagedSub(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACPackagedSubEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_packaged_unit/ACPackagedSubEditModal.js